import React, { useState, useEffect, useCallback } from 'react';

const HeroCarousel = () => {
  const images = [
    { src: '/images/slideshow/slide1.png', caption: 'Image 1 caption' },
    { src: '/images/slideshow/slide2.png', caption: 'Image 2 caption' },
    { src: '/images/slideshow/slide3.png', caption: 'Image 3 caption' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);

  const handleNext = useCallback(() => {
    setNextIndex((nextIndex + 1) % images.length);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
    }, 500); // transition duration
  }, [currentIndex, nextIndex, images.length]);

  const handlePrev = useCallback(() => {
    setNextIndex((nextIndex - 1 + images.length) % images.length);
    setTimeout(() => {
      setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    }, 500); // transition duration
  }, [currentIndex, nextIndex, images.length]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleNext();
    }, 4000); // autoplay every 4 seconds
    return () => clearInterval(intervalId);
  }, [handleNext]); // Include handleNext as a dependency

  return (
    <div
      style={{
        width: '100%',
        height: '450px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: currentIndex === nextIndex ? 0 : 1,
          transition: 'opacity 0.5s',
        }}
      >
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].caption}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: '#fff',
            padding: '10px',
            fontSize: '18px',
            fontFamily: 'Playfair Display',
          }}
        >
          {images[currentIndex].caption}
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: currentIndex === nextIndex ? 1 : 0,
          transition: 'opacity 0.5s',
        }}
      >
        <img
          src={images[nextIndex].src}
          alt={images[nextIndex].caption}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: '#fff',
            padding: '10px',
            fontSize: '18px',
            fontFamily: 'Ariel',
          }}
        >
          {images[nextIndex].caption}
        </div>
      </div>
      <button
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: '#fff',
          border: 'none',
          padding: '10px 20px',
          fontSize: '24px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
        onClick={handlePrev}
      >
        &#10094;
      </button>
      <button
        style={{
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translateY(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: '#fff',
          border: 'none',
          padding: '10px 20px',
          fontSize: '24px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
        onClick={handleNext}
      >
        &#10095;
      </button>
    </div>
  );
};

export default HeroCarousel;
